<template>
    <div class="modal fade" id="updateUserModal" role="dialog" aria-labelledby="updateUserModalLabel" backdrop="static" data-backdrop="static" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="updateUserModalLabel">{{$t('aspNetUser.edit')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="mt-3">
                        <div class="form-group">
                            <label class="font-weight-bold required" :for="'nomName' + _uid">{{ $t('registers.nomenclatures.gridHeaders.name')}}</label>
                            <input type="text" class="form-control"
                                   v-model="model.name"
                                   :name="'nomName' + _uid"
                                   :id="'nomName' + _uid"
                                   v-validate="'required'"
                                   :data-vv-as="$t('registers.nomenclatures.gridHeaders.name')">
                            <span class="text-danger">{{ errors.first('nomName' + _uid) }}</span>
                        </div>

                        <div class="form-group">
                            <label class="font-weight-bold" for="nomNameEn">{{ $t('registers.nomenclatures.gridHeaders.nameEn')}}</label>
                            <input type="text" id="nomNameEn" class="form-control" v-model="model.nameEn">
                        </div>

                        <div class="form-group">
                            <label class="font-weight-bold" for="parentNomSort">{{ $t('registers.nomenclatures.gridHeaders.sort')}}</label>
                            <input type="number" id="parentNomSort" class="form-control" v-model="model.sort">
                        </div>

                        <div class="form-group">
                            <label class="font-weight-bold" for="description">{{ $t('registers.nomenclatures.gridHeaders.description')}}</label>
                            <textarea type="text" id="description" class="form-control" v-model="model.description"></textarea>
                        </div>
                    </div>

                    <div class="card-footer text-right">
                        <button type="button" class="btn btn-success" @click.stop="onCreate"><i class="fas fa-save mr-2"></i>{{ $t('buttons.save.btnText')}}</button>
                        <button type="button" class="btn btn-danger" @click.stop="hide"><i class="fas fa-ban mr-2"></i>{{ $t('buttons.cancel')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ForeignCity } from "@/models/models";

export default {
    props: {
        value: {
            type: Boolean,
            required: false
        },
        foreignCitiesParentId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            model: new ForeignCity(),
        };
    },
    methods: {
        onClose() {
            this.$emit('onClose', { ...this.model });
            this.model = new ForeignCity({ parentId: this.foreignCitiesParentId });
            this.$validator.reset();
            this.$emit('input', false);
        },
        hide() {
            $(this.$el).modal('hide');
        },
        onCancel() {
            this.onClose();
        },
        showModal() {
            $(this.$el).modal('show');
        },
        async onCreate() {
            try {
                await this.$http.post('/api/cities/create', this.model);
                this.$emit('cityCreated');
                this.onClose();
            } catch (error) {
                this.$vs.notify({
                    title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                    text: this.$helpers.errorText(error),
                    color: this.$helpers.errorColor(error),
                    time: this.$store.getters.notificationDuration
                })
            }
        },
    },
    mounted() {
        // add modal close listener
        $(this.$el).on('hidden.bs.modal', this.onClose);
        if (this.show) {
            this.showModal();
        }
    },
    beforeDestroy() {
        // remove listener
        $(this.$el).off('hidden.bs.modal');
    },
    watch: {
        value: function (val) {
            if (val) {
                this.model.selectedIds = [];
                this.model.editActive = false;
                this.model.active = false;
                this.showModal();
            } else {
                this.hide();
            }
        },
        foreignCitiesParentId: function() {
            this.model.parentId = this.foreignCitiesParentId;
        }
    }
};
</script>
